module.exports = __webpack_public_path__ + "img/Natori.33ef8c90.png";